import React from 'react'

export const ReKeyboardAccessory: React.FunctionComponent = () => null
